function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import reject from 'lodash/reject';
import findIndex from 'lodash/findIndex';
import includes from 'lodash/includes';
import inRange from 'lodash/inRange';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { DEFAULT_NOTIFICATION_FILTER } from './constants';
import * as actionTypes from './actionTypes';
const initialState = {
    notifications: {},
    notificationsFilter: DEFAULT_NOTIFICATION_FILTER,
    lastReceivedNotification: null,
    fetching: [],
    sending: [],
    errors: []
};
// eslint-disable-next-line default-param-last
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.FETCH_LIST:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_LIST),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_LIST)
                });
            }
        case actionTypes.FETCH_LIST_SUCCESS:
            {
                const { notifications } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    notifications,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_LIST)
                });
            }
        case actionTypes.FETCH_LIST_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_LIST),
                    errors: registerAction(state.errors, actionTypes.FETCH_LIST)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ADD_NEW_NOTIFICATION:
            {
                const { notification } = action.payload;
                const { notificationsFilter } = state;
                const updatedNotifications = {
                    totalRecords: state.notifications.totalRecords + 1,
                    totalActiveRecords: state.notifications.totalActiveRecords + 1,
                    records: [
                        notification,
                        ...state.notifications.records
                    ]
                };
                const { status, timestamp, notificationTrigger } = notification;
                const { notificationStatuses, fromTimestamp, toTimestamp, notificationTriggers } = notificationsFilter;
                const isInFiltersRange = (!notificationStatuses.length || includes(notificationStatuses, status)) && (!notificationTriggers.length || includes(notificationTriggers, notificationTrigger)) && inRange(timestamp, fromTimestamp || Number.MIN_VALUE, toTimestamp || Number.MAX_VALUE);
                if (isInFiltersRange) {
                    updatedNotifications.records = [
                        notification,
                        ...state.notifications.records
                    ];
                } else {
                    updatedNotifications.records = [
                        ...state.notifications.records
                    ];
                }
                return _object_spread_props(_object_spread({}, state), {
                    notifications: updatedNotifications,
                    lastReceivedNotification: notification
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DISMISS_NOTIFICATION:
            {
                const { notification } = action.payload;
                const { instantNotificationId } = notification;
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.fetching, `${actionTypes.DISMISS_NOTIFICATION}-${instantNotificationId}`),
                    errors: unregisterAction(state.errors, `${actionTypes.DISMISS_NOTIFICATION}-${instantNotificationId}`)
                });
            }
        case actionTypes.DISMISS_NOTIFICATION_SUCCESS:
            {
                const { notification } = action.payload;
                const { instantNotificationId } = notification;
                let updatedNotifications = {
                    totalActiveRecords: notification.status === 'Active' ? state.notifications.totalActiveRecords - 1 : state.notifications.totalActiveRecords,
                    totalRecords: state.notifications.totalRecords,
                    records: [
                        ...state.notifications.records
                    ]
                };
                const { notificationsFilter } = state;
                if (includes(notificationsFilter.notificationStatuses, 'Dismissed')) {
                    const idx = findIndex(updatedNotifications.records, {
                        instantNotificationId
                    });
                    updatedNotifications.records[idx] = _object_spread_props(_object_spread({}, notification), {
                        status: 'Dismissed'
                    });
                } else {
                    updatedNotifications = _object_spread_props(_object_spread({}, updatedNotifications), {
                        records: reject(updatedNotifications.records, {
                            instantNotificationId
                        })
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    notifications: updatedNotifications,
                    sending: unregisterAction(state.fetching, `${actionTypes.DISMISS_NOTIFICATION}-${instantNotificationId}`)
                });
            }
        case actionTypes.DISMISS_NOTIFICATION_ERROR:
            {
                const { notification } = action.payload;
                const { instantNotificationId } = notification;
                const { notifications } = state;
                const idx = findIndex(notifications, {
                    instantNotificationId
                });
                notifications[idx] = _object_spread_props(_object_spread({}, notification), {
                    status: 'Error'
                });
                return _object_spread_props(_object_spread({}, state), {
                    notifications,
                    sending: unregisterAction(state.fetching, `${actionTypes.DISMISS_NOTIFICATION}-${instantNotificationId}`),
                    errors: registerAction(state.errors, `${actionTypes.DISMISS_NOTIFICATION}-${instantNotificationId}`)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.DISMISS_FILTERED_NOTIFICATIONS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.DISMISS_FILTERED_NOTIFICATIONS),
                    errors: unregisterAction(state.errors, actionTypes.DISMISS_FILTERED_NOTIFICATIONS)
                });
            }
        case actionTypes.DISMISS_FILTERED_NOTIFICATIONS_CANCEL:
        case actionTypes.DISMISS_FILTERED_NOTIFICATIONS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DISMISS_FILTERED_NOTIFICATIONS)
                });
            }
        case actionTypes.DISMISS_FILTERED_NOTIFICATIONS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.DISMISS_FILTERED_NOTIFICATIONS),
                    errors: registerAction(state.errors, actionTypes.DISMISS_FILTERED_NOTIFICATIONS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.MARK_NOTIFICATIONS_READ:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.fetching, actionTypes.MARK_NOTIFICATIONS_READ),
                    errors: unregisterAction(state.errors, actionTypes.MARK_NOTIFICATIONS_READ)
                });
            }
        case actionTypes.MARK_NOTIFICATIONS_READ_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.fetching, actionTypes.MARK_NOTIFICATIONS_READ)
                });
            }
        case actionTypes.MARK_NOTIFICATIONS_READ_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.fetching, actionTypes.MARK_NOTIFICATIONS_READ),
                    errors: registerAction(state.errors, actionTypes.MARK_NOTIFICATIONS_READ)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_NOTIFICATIONS_FILTER_PARAMS:
            {
                const { notificationsFilterParams } = action.payload;
                const { notificationsFilter } = state;
                return _object_spread_props(_object_spread({}, state), {
                    notificationsFilter: _object_spread({}, notificationsFilter, notificationsFilterParams)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
